<template>
  <NavBar v-bind="$attrs" />
</template>

<script setup>
import NavBar from '@/components/NavBar.vue';
</script>
